import { render } from "./DataForm2.vue?vue&type=template&id=2c96c35c&scoped=true"
import script from "./DataForm2.vue?vue&type=script&lang=js"
export * from "./DataForm2.vue?vue&type=script&lang=js"

import "./DataForm2.vue?vue&type=style&index=0&id=2c96c35c&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c96c35c"]])

export default __exports__